import { Reward } from '../models/Base';

const getExtraReward = (answerSlots: number) => {
  switch (true) {
    case answerSlots >= 1 && answerSlots <= 6:
      return 0;
    default:
      return Math.max(answerSlots - 6, 0);
  }
};

const setZeroValuesToNil = (obj: Reward) => {
  Object.keys(obj).forEach((_key) => {
    const key = _key as keyof Reward;
    if (obj[key]) {
      const value = obj[key];
      if (typeof value === 'number' && value > 0) {
        obj[key] = value;
      } else {
        delete obj[key];
        obj[key] = undefined;
      }
    }
  });
};

export const computeReward = (
  isAtLeastMember: boolean | undefined,
  reward: Reward,
  isWinner: boolean,
  star: number,
  claimed: (Reward | undefined)[],
  multiple = 1,
  answerSlots = 0,
) => {
  const classroomCredit = reward.joyPoint || 0;
  const extraReward = getExtraReward(answerSlots);

  let r = { ...reward };
  r.joyPoint = (r.joyPoint || 0) + extraReward;
  r.classroomCredit = undefined;
  if (isAtLeastMember) {
    r.classroomCredit = classroomCredit + extraReward;
  }
  Object.keys(r).forEach((_key) => {
    const key = _key as keyof Reward;
    r[key] = Math.max(0, (r[key] || 0) * multiple);
  });

  r = claimed.reduce<Reward>((acc, cur) => {
    if (cur) {
      Object.keys(acc).forEach((_key) => {
        const key = _key as keyof Reward;
        acc[key] = Math.max(0, (acc[key] || 0) - (cur[key] || 0));
      });
    }
    return acc;
  }, r);

  Object.keys(r).forEach((_key) => {
    const key = _key as keyof Reward;
    r[key] = Math.max(0, Math.ceil((r[key] || 0) * (0.2 * star)));
  });

  r.exp = r.joyPoint || 0;
  setZeroValuesToNil(r);

  let memberReward = null;
  if (isAtLeastMember) {
    memberReward = {
      puzzlePieces: [],
      classroomCredit: r.classroomCredit || 0,
    };
  }

  return {
    reward: r,
    memberReward: memberReward,
    winnerReward: isWinner ? { exp: 10, joyPoint: 10 } : null,
  };
};
